export default "__VITE_ASSET__DPxh9shZ__"